import { Component, OnInit, ViewEncapsulation, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogData } from 'src/app/model/data.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import lifeQuoteJson from '../../life-config/lifeQuotesConfig.json';
import productConfig from '../../life-config/productCodeConfig.json';
import { SharedDataService } from '../../services/shared-data.service';

@Component({
    selector: 'app-comparison-modal',
    templateUrl: './comparison-modal.component.html',
    styleUrls: ['./comparison-modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ComparisonModalComponent implements OnInit {

    comparisonJson = lifeQuoteJson['comparisonInfo'];
    productConf = productConfig.product_type;
    comparisonForm: FormGroup;
    compareQuotesList = [];
    compareProposalInfo: {};
    paymentFrequencyValue: number;
    isFormVisible = false;
    compareFeatureKeyList = [];
    maturityBenefit = [];
    deathBenefit = [];
    featureValueList = [];

    constructor(
        private dialogRef: MatDialogRef<ComparisonModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private formbuild: FormBuilder,
        private sharedDataService: SharedDataService,
        private apiService: ApiService,
    ) {
        this.compareQuotesList = data['modalData'];
        this.compareProposalInfo = data['proposalInfo'];
        this.paymentFrequencyValue = data['paymentFrequency'];


        // Initilaizing form
        this.comparisonForm = this.formbuild.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this.getQuotationsFeatureList();
    }

    /**
     * email form
     */
    openForm() {
        this.isFormVisible = true;
    }

     // Shares Email Address with quote component to invoke Email comparison API.
    emailComparison(isValid: boolean, event: any) {
        const emailAddress = this.comparisonForm.get('email').value;

        if (isValid) {
            this.sharedDataService.invokeEmailComparison(emailAddress);

        }
    }

    /**
     * getting all the required feature value of selected all insurers
     * doing this as getting all keys from 2 different apis and on FE
     */

    getQuotationsFeatureList() {

        let featuresValue = {};

        // change this as it is not working properly if using object
        this.compareQuotesList.forEach(item => {

            // getting death and maturity benefit data in plan is savings plan
            if (this.compareProposalInfo['product_type'] === this.productConf['savingProductType']) {

                item['saving_benefits'].forEach(ele => {

                    if (ele['label'] === this.comparisonJson['labels']['deathBenefit']) {
                        this.deathBenefit['name'] = ele['label'];
                        this.deathBenefit.push(ele);
                    }

                    if (ele['label'] === this.comparisonJson['labels']['maturityBenefit']) {
                        this.maturityBenefit['name'] = ele['label'];
                        this.maturityBenefit.push(ele);
                    }

                });

            }

            /**
             * parsing data based on feature keys
             * creating key value pair to show data in ui
             */

            item.featureValueList = [];

            // Premium
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['base_premium'],
            };

            if (item['base_premium']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: item['base_premium']
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Max coverage upto
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['compare_max_maturity_age'],
            };

            if (item['config']['compare_max_maturity_age']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: item['config']['compare_max_maturity_age']
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Premium Payment Term
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['premium_term'],
            };

            if (this.compareProposalInfo['premium_term']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: this.compareProposalInfo['premium_term'] + ' ' + 'Years'
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Claim settlement ratio
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['claim_settlement_ratio'],
            };

            if (item['config']['claim_settlement_ratio']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: item['config']['claim_settlement_ratio'] + '%'
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Free look period
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['freelook_period']
            };

            if (item['config']['freelook_period']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: item['config']['freelook_period']
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Solvency ratio
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['solvency_ratio'],
            };

            if (item['config']['solvency_ratio']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: item['config']['solvency_ratio']
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Return of premium
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['return_of_premium'],
            };

            if (item['config']['return_of_premium']) {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: item['config']['return_of_premium']
                })
            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // getting exclusions info
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['exclusions']
            };

            if (item['config']['exclusions']) {

                const exclusionsList = [];

                item['config']['exclusions'].filter((ele, index) => {
                    const obj = {
                        name: ele['label']
                    }
                    exclusionsList.push(obj);
                })

                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: exclusionsList,
                    isList: true
                });

            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Medical Required
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['required_medical']
            };

            if (item['config']['required_medical'] && item['config']['required_medical'].length > 0) {

                const medicalData = [];

                item['config']['required_medical'].filter(ele => {
                    medicalData.push(ele);
                })

                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: medicalData
                });

            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Tax benfit
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['key_benefits']
            };

            if (item['config']['key_benefits']) {

                item['config']['key_benefits'].filter(ele => {

                    if (ele['label'] === this.comparisonJson['featureKeysName']['key_benefits']) {

                        featuresValue = Object.assign({}, featuresValue, {
                            displayVal: 'covered'
                        });

                    }
                });

            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

            // Riders
            featuresValue = {
                name: this.comparisonJson['featureKeysName']['riders']
            };

            if (item['riders'] && item['riders'].length > 0) {

                const riderData = [];

                item['riders'].filter(ele => {
                    const obj = {
                        name: ele['rider_name'],
                        value: ele['benefit']
                    }
                    riderData.push(obj);
                })

                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: riderData,
                    isList: true
                });

            } else {
                featuresValue = Object.assign({}, featuresValue, {
                    displayVal: 'not covered'
                })
            }

            item.featureValueList.push(featuresValue);

        });

        this.getQuotationsFeatureKeyList();

    }

    /**
     * getting all the required feature keys of selected all insurers
     * doing this beacuse the header should be one and value can be mutiple based
     * on no of selected insurers
     */
    getQuotationsFeatureKeyList() {

        if (this.compareQuotesList[0]['featureValueList'] && this.compareQuotesList[0]['featureValueList'].length > 0) {

            this.compareQuotesList[0]['featureValueList'].forEach((eleName, index) => {

                const obj = {
                    id: index,
                    name: eleName['name']
                }

                this.compareFeatureKeyList.push(obj);

            });
        }

    }

    // close dialog box
    closeComparisonDialog() {
        this.dialogRef.close();
    }

    // Shares selected quote data with quote component to invoke create/update Proposals API.
    buyNow(quoteObj, event) {

        // Closes the comparison dialog
        this.dialogRef.close();

        this.sharedDataService.invokeComparisonQuoteData(quoteObj, event);
    }

    ngOnInit() {
    }

}
